export default __webpack_public_path__ + "static/media/16_bitcoin.bca91b7c.svg";